declare const lavendlaObituary: {
  common: Record<string, string>;
  currentEvents: Record<string, string>;
  memoryBook: Record<string, string>;
};

/** `currentEvents` in Translations.php. */
export function highlightTexts(): Record<string, string> {
  return lavendlaObituary.currentEvents;
}

export function commonTexts(): Record<string, string> {
  return lavendlaObituary.common;
}

/** `memoryBook` in Translations.php. */
export function memoryBookTexts(): Record<string, string> {
  return lavendlaObituary.memoryBook;
}
